import React, { ReactNode, useRef } from 'react';
import { styled } from '@mui/material';

import CustomSlickSlider from '@/components/CustomSlickSlider';
import NextArrowButton from './NextArrowButton';
import PrevArrowButton from './PrevArrowButton';

interface CareersSliderProps {
  arrowColor?: string;
  children: ReactNode;
}

const SliderWrap = styled('div')`
  .slick-slider {
    position: relative !important;
  }
  .slick-track {
    display: flex !important;
    align-items: flex-start;
    margin: 0 !important;
    padding: 1.25rem 0 !important;
    .slick-slide {
      margin: 0 0.75rem !important;
    }
  }
  .slick-next:before,
  .slick-prev:before {
    content: '' !important;
  }

  .slick-prev:hover,
  .slick-prev:focus,
  .slick-next:hover,
  .slick-next:focus {
    color: ${({ theme }) => theme.palette.grey[200]};
    outline: inherit;
    background: ${({ theme }) => theme.palette.common.white};
    background-color: ${({ theme }) => theme.palette.common.white};
  }
`;

const CareersSlider = ({
  children,
  arrowColor,
}: CareersSliderProps): JSX.Element => {
  const sliderRef = useRef(null);

  const gotoNext = () => {
    sliderRef.current?.slickNext();
  };

  const gotoPrev = () => {
    sliderRef.current?.slickPrev();
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: true,
    variableWidth: true,
    nextArrow: <NextArrowButton onClick={gotoNext} defaultSlidesToShow={2} />,
    prevArrow: <PrevArrowButton onClick={gotoPrev} />,
  };

  return (
    <SliderWrap>
      <CustomSlickSlider ref={sliderRef} {...settings}>
        {children}
      </CustomSlickSlider>
    </SliderWrap>
  );
};

export default CareersSlider;
